import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentSettings from "../../myComp/ContentSettings";

class TrainingGet extends PlusComponent {
  constructor(props) {
    super(props, "contentVideo");         
  }

  render(){     
    return (
        <div>
          <ContentSettings {...this.props} controller="contentTraining"></ContentSettings>
        </div>
      )
    }
}

export default TrainingGet;